module.exports = __webpack_public_path__ + "static/rotimi-5512b1d69febfd2aaafd0fc88ceaaf74.png";